import { render, staticRenderFns } from "./SchedulingWidget.vue?vue&type=template&id=52397520&scoped=true"
import script from "./SchedulingWidget.vue?vue&type=script&lang=js"
export * from "./SchedulingWidget.vue?vue&type=script&lang=js"
import style0 from "./SchedulingWidget.vue?vue&type=style&index=0&id=52397520&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52397520",
  null
  
)

export default component.exports